import React, { SVGProps } from 'react';

export const SvgLunker = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="11"
      height="10"
      viewBox="0 0 11 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_247_8392)">
        <path
          d="M6.02333 1.61975C5.85754 1.80055 5.62062 1.90558 5.37018 1.90919C5.17569 1.90819 4.98702 1.84565 4.83289 1.7314L3.49787 4.0527L2.0807 3.10883C1.95485 3.45038 1.61975 3.67868 1.24367 3.67908C1.15006 3.67908 1.05729 3.66465 0.968262 3.63659L1.07976 8.47644C1.08412 8.66184 1.24117 8.81017 1.43358 8.81037L9.58197 8.8226C9.775 8.8228 9.93267 8.67447 9.93704 8.48866L10.05 3.58648C9.95597 3.61935 9.85675 3.63659 9.7567 3.63759C9.39933 3.63418 9.07879 3.42472 8.94317 3.10622L7.44778 4.07455L6.02354 1.62015L6.02333 1.61975ZM5.46045 2.0497L7.01658 4.7314C7.06484 4.81478 7.14721 4.87471 7.24352 4.89696C7.33983 4.91921 7.44154 4.90157 7.52371 4.84825L9.3386 3.67287L9.23563 8.13869L1.78075 8.12747L1.6782 3.67126L3.41654 4.82901C3.49891 4.88393 3.60146 4.90257 3.69881 4.88053C3.79637 4.85848 3.87957 4.79794 3.92804 4.71356L5.46024 2.0497H5.46045Z"
          fill="currentColor"
        />
        <path
          d="M1.43466 9.30444C1.23893 9.30424 1.0798 9.45678 1.07959 9.64559C1.07938 9.83421 1.23768 9.98755 1.43362 9.98775L9.58201 9.99997C9.77775 10.0002 9.93688 9.84764 9.93708 9.65882C9.93729 9.47021 9.779 9.31687 9.58305 9.31667L1.43466 9.30444Z"
          fill="currentColor"
        />
        <path
          d="M1.20043 1.62398C0.541659 1.62398 0 2.14593 0 2.78052C0 3.41512 0.541659 3.93727 1.20043 3.93727C1.8592 3.93727 2.40085 3.41532 2.40085 2.78052C2.40085 2.14573 1.8592 1.62378 1.20043 1.62378V1.62398ZM1.20043 2.30728C1.47583 2.30728 1.69175 2.51514 1.69175 2.78052C1.69175 3.04591 1.47604 3.25377 1.20043 3.25377C0.924814 3.25377 0.709315 3.04591 0.709315 2.78052C0.709315 2.51514 0.925022 2.30728 1.20043 2.30728Z"
          fill="currentColor"
        />
        <path
          d="M5.41356 0C4.75479 0 4.21313 0.521748 4.21313 1.15654C4.21313 1.79134 4.75479 2.31329 5.41356 2.31329C6.07233 2.31329 6.61378 1.79134 6.61378 1.15654C6.61378 0.521748 6.07233 0 5.41356 0ZM5.41356 0.683303C5.68897 0.683303 5.90467 0.891161 5.90467 1.15654C5.90467 1.42193 5.68897 1.62999 5.41356 1.62999C5.13816 1.62999 4.92224 1.42213 4.92224 1.15654C4.92224 0.89096 5.13795 0.683303 5.41356 0.683303Z"
          fill="currentColor"
        />
        <path
          d="M9.79958 1.62402C9.14082 1.62402 8.59937 2.14597 8.59937 2.78077C8.59937 3.41556 9.14082 3.93751 9.79958 3.93751C10.4584 3.93751 11 3.41556 11 2.78077C11 2.14597 10.4584 1.62402 9.79958 1.62402ZM9.79958 2.30733C10.075 2.30733 10.2909 2.51518 10.2909 2.78057C10.2909 3.04595 10.0752 3.25381 9.79958 3.25381C9.52397 3.25381 9.30847 3.04595 9.30847 2.78057C9.30847 2.51518 9.52418 2.30733 9.79958 2.30733Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_247_8392">
          <rect width="11" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
